import { isDateRangesOverlapping } from 'util/dateTime';

export const hasShiftConflict = ({ shifts, startAt, endAt, jobId }) => {
  if (!shifts.length) return false;

  return shifts.some(shift => {
    if (shift.owner.type === 'job' && shift.owner.id === jobId) {
      return isDateRangesOverlapping(
        [startAt, endAt],
        [shift.startAt, shift.endAt]
      );
    }
    return false;
  });
};

/** leave attrs here til dept gets migrated */
export const sortByName = (a, b) => {
  const nameA = (a?.name || a?.attributes?.name || '').toLowerCase();
  const nameB = (b?.name || b?.attributes?.name || '').toLowerCase();

  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};

export const getUser = (userIdEmployeeNameMap, jobIdUserIdMap, jobId) =>
  userIdEmployeeNameMap[jobIdUserIdMap[jobId]];

export const sortByAttribute = (
  primaryAttributeA,
  primaryAttributeB,
  secondaryAttributeA,
  secondaryAttributeB
) => {
  if (primaryAttributeA < primaryAttributeB) return -1;
  if (primaryAttributeA > primaryAttributeB) return 1;

  if (primaryAttributeA === primaryAttributeB) {
    if (secondaryAttributeA < secondaryAttributeB) return -1;
    if (secondaryAttributeA > secondaryAttributeB) return 1;
  }
  return 0;
};
